"use client"

import { useEffect } from "react"

const SELECTORS_TO_REMOVE = [
  ".iubenda-cs-brand-badge-outer",
  ".iub-iframe-brand-button",
  ".iubenda-tp-btn.iubenda-cs-preferences-link",
  // Note: We keep .iubenda-uspr-btn for the privacy sidebar
]

export function NukeNodes() {
  useEffect(() => {
    const removeAll = () => {
      try {
        SELECTORS_TO_REMOVE.forEach((sel) => {
          document.querySelectorAll(sel).forEach((n) => n.remove())
        })
      } catch (_) {
        // no-op
      }
    }

    removeAll()
    const obs = new MutationObserver(removeAll)
    obs.observe(document.documentElement, { childList: true, subtree: true })
    return () => obs.disconnect()
  }, [])

  return null
}


